import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../pages/Dashboard/Sidebar/Sidebar";
import Loader from "../Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import Select from "react-select";
import { toastError, toastSuccess } from "../../common/Toast";
import axios from "axios";
import config from "../../config/config";

const RegisterAddRemoveAmount = () => {
  const { currencyValues, registerConfig, registerId } = useContext(AppContext);
  const searchParams = new URLSearchParams(window.location.search);
  let type = searchParams.get("type");
  let paymentMethod = searchParams.get("method") || "";
  const loginUserId = localStorage.getItem("ID") || "";
  const Location = localStorage.getItem("Location") || "";
  const navigate = useNavigate();
  // const registerId = localStorage.getItem("registerId") || "";
  const regId = registerId || 0;
  const userRegisterId = localStorage.getItem("UserRegisterId") || 0;
  const token = localStorage.getItem("Token") || "";
  const [amount, setAmount] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(paymentMethod);
  const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
  const paymentMap = {
    TrackCashInRegister: "Cash",
    TrackChecksInRegister: "Check",
    TrackCreditCardsInRegister: "CreditCard",
    TrackDebitCardsInRegister: "DebitCard",
    TrackGiftcardsInRegister: "GiftCard",
  };

  const updatedPaymentMethods = registerConfig
    .filter(
      (config) =>
        config.AppConfigvalue === "true" && paymentMap[config.AppConfigkey]
    )
    .map((config) => paymentMap[config.AppConfigkey]);

  console.log(updatedPaymentMethods, "updatedPaymentMethods");

  const paymentMethodsFormatted = updatedPaymentMethods.map((method) => ({
    label: method, // Use appropriate key for label
    value: method, // Use appropriate key for value
  }));

  const [totalPrevamount, setTotalPrevamount] = useState({
    CashTotalAdditions: 0,
    CheckTotalAdditions: 0,
    GiftCardTotalAdditions: 0,
    DebitCardTotalAdditions: 0,
    CreditCardTotalAdditions: 0,
    CashTotalSubtractions: 0,
    CheckTotalSubtractions: 0,
    GiftCardTotalSubtractions: 0,
    DebitCardTotalSubtractions: 0,
    CreditCardTotalSubtractions: 0,
  });

  useEffect(() => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/getposregisterdetailsbyid?registerId=${userRegisterId}&locationId=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        let takeResData = res.data.ResponseData[0];
        const latestShift = takeResData[0];
        console.log(takeResData, "takeResDatatakeResData");
        setTotalPrevamount({
          CashTotalAdditions: parseFloat(latestShift.CashTotalAdditions) || 0,
          CheckTotalAdditions: parseFloat(latestShift.CheckTotalAdditions) || 0,
          GiftCardTotalAdditions:
            parseFloat(latestShift.GiftCardTotalAdditions) || 0,
          DebitCardTotalAdditions:
            parseFloat(latestShift.DebitCardTotalAdditions) || 0,
          CreditCardTotalAdditions:
            parseFloat(latestShift.CreditCardTotalAdditions) || 0,
          CashTotalSubtractions:
            parseFloat(latestShift.CashTotalSubtractions) || 0,
          CheckTotalSubtractions:
            parseFloat(latestShift.CheckTotalSubtractions) || 0,
          GiftCardTotalSubtractions:
            parseFloat(latestShift.GiftCardTotalSubtractions) || 0,
          DebitCardTotalSubtractions:
            parseFloat(latestShift.DebitCardTotalSubtractions) || 0,
          CreditCardTotalSubtractions:
            parseFloat(latestShift.CreditCardTotalSubtractions) || 0,
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  },[]);

  const handleChange = (event) => {
    console.log(event, "eventevent");
    setSelectedPayment(event.value);
  };
  const handleSave = () => {
    if (selectedPayment === "") {
      toastError("Please select payment method");
      return;
    }

    if (amount === "") {
      toastError("Please enter amount");
      return;
    }

    let payloadData = {
      registerId: userRegisterId,
      paymentType: selectedPayment,
      amount: amount,
      comment: comments,
      addRemoveType: type,
      loginUserId: loginUserId,
    };

    setLoading(true);

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/registeraddremoveamountupsert`,
        payloadData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          console.log("check 778899");
          toastSuccess(SUCCESS_MESSAGE);
          setLoading(false);
          navigate(-1);
          // navigate(`/sales-receipt/${res.data.ResponseID}`);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  console.log(updatedPaymentMethods, "paymentMethodscheck");
  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/pos">Sales</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link>
                    {type === "add"
                      ? "Add cash to register"
                      : "Remove cash from register"}
                  </Link>
                </li>
                {/* <li className="breadcrumb-item active">Manage Employee</li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className={"col-lg-12 col-md-12"}>
            <div className="card bg-white">
              <div className="card-body">
                <p className="text-xl font-semibold border-bottom bg-gray-200 p-2">
                  Use the form below to {type} cash to register
                </p>
                <div className="max-w-md mx-auto p-4 rounded-lg shadow-md bg-white">
                  <label className="col-form-label">
                    Select Payment Method:<span className="text-danger">*</span>
                  </label>
                  <div className="row">
                    <div className="col-md-4">
                      <Select
                        onChange={handleChange}
                        value={paymentMethodsFormatted.filter((obj) =>
                          selectedPayment.includes(obj.value)
                        )}
                        options={paymentMethodsFormatted}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        // isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        // className="custom-search-select"
                        placeholder="Select payment method"
                        name="paymentMethod"
                        id="paymentMethod"
                      />
                    </div>
                  </div>
                </div>
                <div className="max-w-md mx-auto p-4 rounded-lg shadow-md bg-white">
                  {/* <p className="text-lg font-bold mb-4">
                    {type === "add"
                      ? "You have already added $0.00 to the register"
                      : "You have already subtracted $0.00 to the register"}
                  </p> */}
                  <p className="text-lg font-bold mb-4">
                    {type === "add"
                      ? `You have already added $${
                          totalPrevamount[
                            paymentMethod + "TotalAdditions"
                          ]?.toFixed(2) || "0.00"
                        } to the register`
                      : `You have already subtracted $${
                          totalPrevamount[
                            paymentMethod + "TotalSubtractions"
                          ]?.toFixed(2) || "0.00"
                        } from the register`}
                  </p>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                      Additional Amount To {capitalizedType} To Register:
                    </label>
                    <input
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="w-full mt-1 p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                      Comments:
                    </label>
                    <textarea
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                      className="w-full mt-1 p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                      rows="4"
                    ></textarea>
                  </div>

                  <button
                    onClick={handleSave}
                    className="btn btn-sm btn-primary pull-right"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterAddRemoveAmount;
